import { IconProps } from "../../../types/style";

const BuildingSingleFillSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          opacity="0.4"
          d="M6.24937 3.70499V11H2.03937C1.45937 11 0.984375 10.535 0.984375 9.96499V2.54499C0.984375 1.23499 1.96438 0.639991 3.15938 1.22499L5.37437 2.31999C5.85437 2.55499 6.24937 3.17999 6.24937 3.70499Z"
          fill={color}
        />
        <path
          d="M4.485 4.875H2.75C2.545 4.875 2.375 4.705 2.375 4.5C2.375 4.295 2.545 4.125 2.75 4.125H4.485C4.69 4.125 4.86 4.295 4.86 4.5C4.86 4.705 4.695 4.875 4.485 4.875Z"
          fill={color}
        />
        <path
          d="M4.485 6.875H2.75C2.545 6.875 2.375 6.705 2.375 6.5C2.375 6.295 2.545 6.125 2.75 6.125H4.485C4.69 6.125 4.86 6.295 4.86 6.5C4.86 6.705 4.695 6.875 4.485 6.875Z"
          fill={color}
        />
        <path
          opacity="0.6"
          d="M11 7.52496V9.74996C11 10.44 10.44 11 9.75 11H6.25V5.20996L6.485 5.25996L8.505 5.70996L8.745 5.76496L9.765 5.99496C10.01 6.04496 10.235 6.12996 10.43 6.25496C10.43 6.25996 10.435 6.25996 10.435 6.25996C10.485 6.29496 10.535 6.33496 10.58 6.37996C10.81 6.60996 10.96 6.94496 10.995 7.43496C10.995 7.46496 11 7.49496 11 7.52496Z"
          fill={color}
        />
        <path
          d="M6.25 5.20996V8.20996C6.48 8.51496 6.84 8.70996 7.25 8.70996C7.945 8.70996 8.505 8.14996 8.505 7.45996V5.71496L6.485 5.26496L6.25 5.20996Z"
          fill={color}
        />
        <path
          d="M10.9949 7.43496C10.9599 6.94496 10.8099 6.60996 10.5799 6.37996C10.5349 6.33496 10.4849 6.29496 10.4349 6.25996C10.4349 6.25996 10.4299 6.25996 10.4299 6.25496C10.2349 6.12996 10.0099 6.04496 9.76488 5.99496L8.74488 5.76496L8.50488 5.70996V7.45996C8.50488 8.14496 9.05988 8.70996 9.75488 8.70996C10.4249 8.70996 10.9599 8.18496 10.9999 7.52996V7.52496C10.9999 7.49496 10.9949 7.46496 10.9949 7.43496Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BuildingSingleFillSVG;
